<template>
  <NuxtLink :to="item?.link || '/'" class="group block relative">
    <div
      class="aspect-[375/470] w-full lg:max-h-[900px] cursor-pointer bg-primary"
      :style="{
        filter: `brightness(${data.image_brightness_filter || 100}%)`,
      }"
    >
      <UiLazyImg
        class="h-full w-full opacity-80 group-hover:opacity-100 transition-opacity duration-300 ease-out"
        :src="
          getImageByPosition(item.medias, 'list')?.file?.url ||
          '/images/no-image.webp'
        "
        :alt="imageAlt(item)"
        img-classes="object-cover"
      />
    </div>
    <div
      class="absolute left-0 bottom-4 lg:bottom-6 w-full px-4 lg:px-6 space-y-4"
      :style="
        { textAlign: data?.card_content_position || 'left' } as StyleValue
      "
    >
      <h3>
        <span
          class="ui-h2 lg:text-5xl text-white uppercase font-normal animated-underline group-hover:after:w-full after:!bottom-1"
        >
          {{ item.currentTranslation?.title }}
        </span>
      </h3>
      <div
        v-if="
          item?.show_short_description &&
          item.currentTranslation?.short_description
        "
        class="text-white"
        v-html="item.currentTranslation?.short_description"
      />
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import { StyleValue } from "vue";
import { BlockEntitiesContent, BlockEntity, EntityData } from "ecom-types";

defineProps<{
  data: BlockEntitiesContent;
  item: EntityData &
    Pick<BlockEntity, "active" | "link" | "show_short_description">;
}>();
const { t } = useI18n();

function imageAlt(item: EntityData & Pick<BlockEntity, "active" | "link">) {
  if (getImageByPosition(item.medias, "list")?.alt) {
    return getImageByPosition(item.medias, "list")?.alt;
  } else if (item.currentTranslation?.title) {
    return `${t("image")} ${item.currentTranslation?.title}`;
  } else {
    return t("image");
  }
}
</script>
